export const siteSettings = {
  name: "Essence Markets",
  link: "https://essencetrademarket.net",
  email: "support@essencetrademarket.net",
  appLink: "https://app.essencetrademarket.net",
};
